/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getLikes.defs'
export { main as default } from './getLikes.defs'
